export const ru = {
  // Header
  header: {
    title: "Простая и быстрая замена голоса в вашем видео на любом языке!",
    subtitle: "🔥Платите только за результат – всего $0.099 за секунду.🔥"
  },

  // Steps
  steps: {
    uploadVideo: "Загрузить видео",
    selectLanguages: "Выбрать языки", 
    conversionResult: "Конвертация и результат"
  },

  // Upload section
  upload: {
    dragAndDrop: "Перетащите видеофайл сюда",
    orClickToSelect: "или нажмите для выбора",
    supportedFormats: "Поддерживаемые форматы: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Максимальный размер файла: 250 МБ",
    maxDuration: "• Максимальная длительность: 15 мин",
    processingTime: "• Обработка займет от 2 до 15 минут в зависимости от разрешения видео",
    chooseFile: "Выбрать файл",
    selectedFile: "Выбранный файл:",
    size: "Размер:",
    fileTypeError: "Пожалуйста, выберите видеофайл",
    fileSizeError: "Размер файла ({size} МБ) превышает максимальный лимит в 250 МБ",
    durationError: "Длительность видео ({duration} минут) превышает максимальный лимит в 15 минут",
    fileReadError: "Не удается прочитать видеофайл. Пожалуйста, попробуйте другой файл."
  },

  // Language selection
  languages: {
    sourceAudioLanguage: "Исходный язык аудио",
    targetAudioLanguage: "Целевой язык аудио",
    selectLanguage: "Выберите язык..."
  },

  // Language options
  languageOptions: {
    ru: "Русский",
    en: "Английский",
    es: "Испанский",
    fr: "Французский",
    de: "Немецкий",
    it: "Итальянский",
    pt: "Португальский",
    pl: "Польский",
    zh: "Китайский",
    ja: "Японский",
    ko: "Корейский",
    bg: "Болгарский",
    hr: "Хорватский",
    cs: "Чешский",
    da: "Датский",
    nl: "Голландский",
    et: "Эстонский",
    fi: "Финский",
    el: "Греческий",
    hu: "Венгерский",
    ga: "Ирландский",
    lv: "Латышский",
    lt: "Литовский",
    mt: "Мальтийский",
    ro: "Румынский",
    sk: "Словацкий",
    sl: "Словенский",
    sv: "Шведский"
  },

  // Conversion
  conversion: {
    replaceAudio: "Заменить аудио",
    uploadVideoAndSelectLanguages: "Загрузите видео и выберите языки для продолжения",
    fixValidationError: "Пожалуйста, исправьте ошибку валидации файла выше",
    createSubtitles: "Создать субтитры",
    uploadVideoForSubtitles: "Загрузите видео для создания субтитров",
    selectTranslationLanguage: "Выберите язык перевода"
  },

  // Demo video section
  demo: {
    seeVeviInAction: "Посмотрите VEVI в действии",
    watchHowItWorks: "Посмотрите, как работает наша технология замены голоса ИИ",
    beforeEnglish: "До (Английский)",
    originalPresentation: "Оригинальная корпоративная презентация",
    afterSpanish: "После (Испанский,Французский,Китайский,Итальянский)",
    aiTranslatedVoice: "ИИ-перевод с естественным голосом",
    demoTitle: "Демо - VEVI в действии"
  },

  // Reviews
  reviews: {
    title: "Что говорят наши клиенты",
    subtitle: "Нам доверяют маркетинговые профессионалы по всему миру",
    customerReviews: [
      {
        name: "Сара Джонсон",
        position: "Менеджер по цифровому маркетингу",
        company: "TechFlow Solutions",
        text: "VEVI преобразил наши международные маркетинговые кампании! Мы локализовали наши демо-видео продукта для 8 различных рынков всего за один день. Качество невероятное, а ценообразование такое прозрачное."
      },
      {
        name: "Майкл Чен",
        position: "Директор по контент-маркетингу", 
        company: "GlobalReach Media",
        text: "Как человек, который управляет видеоконтентом для нескольких регионов, VEVI - это революция. Замена голоса настолько естественная, что наша аудитория не может понять, что это сгенерировано ИИ. Очень рекомендую!"
      },
      {
        name: "Эмма Родригес",
        position: "Специалист по брендинговому маркетингу",
        company: "InnovateCorp",
        text: "Мы сэкономили тысячи на затратах на озвучку, расширяясь на новые рынки. Цена $0.0314 за секунду невероятно справедливая, и результаты говорят сами за себя. Наши коэффициенты конверсии выросли на 40%!"
      },
      {
        name: "Дэвид Томпсон",
        position: "Менеджер маркетинговых кампаний",
        company: "NextGen Brands",
        text: "Скорость и качество VEVI не имеют равных. Мы перешли от одного английского видео к 12 локализованным версиям на разных языках за считанные часы. Этот инструмент необходим для глобального маркетинга."
      },
      {
        name: "Лиза Парк",
        position: "Руководитель маркетинга в социальных сетях",
        company: "CreativeEdge Agency",
        text: "VEVI сделал возможным для нашего небольшого агентства предлагать многоязычные видеоуслуги клиентам. Качество профессионального уровня, а процесс невероятно простой. Наши клиенты в восторге от результатов!"
      },
      {
        name: "Джеймс Уилсон",
        position: "Директор по производительному маркетингу",
        company: "ScaleUp Ventures",
        text: "ROI - это все в производительном маркетинге, и VEVI поставляет. Мы сократили наши затраты на локализацию видео на 80%, улучшив время выполнения с недель до часов. Этот инструмент окупает себя немедленно."
      }
    ]
  },

  // Payment dialog
  payment: {
    title: "Оплата конвертации",
    processingCost: "Стоимость обработки",
    duration: "Длительность:",
    baseCost: "Базовая стоимость",
    discount: "Скидка ({promoCode}):",
    discountAmount: "Сумма скидки:",
    total: "Итого:",
    emailToReceiveResult: "Email для получения результата",
    emailPlaceholder: "ваш-email@example.com",
    promoCode: "🎟️ Промокод (необязательно)",
    promoCodePlaceholder: "Введите промокод",
    check: "Проверить",
    checking: "Проверяется...",
    addSubtitles: "Добавить субтитры к видео",
    addSubtitlesDescription: "Сгенерировать и встроить субтитры на целевом языке",
    highQualityTranslation: "• Высококачественный ИИ-перевод",
    originalVideoPreserved: "• Оригинальное видео сохранено",
    fastProcessing: "• Быстрая обработка (обычно 5-10 минут)",
    resultWillBeSent: "• Результат будет отправлен на указанный email",
    cancel: "Отмена",
    continue: "Продолжить",
    enterEmail: "Пожалуйста, введите ваш email",
    enterValidEmail: "Пожалуйста, введите корректный email адрес",
    enterPromoCode: "Пожалуйста, введите промокод",
    invalidPromoCode: "Недействительный промокод",
    validPromoCode: "Действительный промокод! Применена скидка {discount}%"
  },

  // Progress dialog
  progress: {
    title: "Обработка видео",
    uploadingVideo: "📤 Загрузка видеофайла...",
    uploadingAndExtracting: "🎬 Загрузка и извлечение аудио",
    transcribingAndTranslating: "🗣️ Транскрибирование речи и перевод", 
    synthesizingAudio: "🎵 Синтез новой аудиодорожки",
    step: "Шаг:",
    error: "Ошибка"
  },

  // Result dialog
  result: {
    title: "Готово! Ваше видео обработано",
    conversionCompleted: "Конвертация успешно завершена!",
    processedVideoDescription: "🎬 Ваше обработанное видео с клонированием голоса",
    payAndDownload: "Оплатить и скачать",
    videoNotAvailable: "Видео недоступно",
    useDownloadButton: "Пожалуйста, используйте кнопку скачивания ниже",
    downloadError: "Ошибка скачивания"
  },

  // Email sent dialog
  emailSent: {
    title: "Видео отправлено! 🎉",
    videoOnWay: "Видео уже отправляется на ваш email 🙏❤️",
    checkInbox: "Проверьте входящие и папку спам. Обработанное видео прибудет в ближайшее время!",
    whatsNext: "Что дальше?",
    checkEmail: "• Проверьте ваш email ({email})",
    checkSpam: "• Посмотрите в папку спам/нежелательная почта, если не нашли",
    downloadAndEnjoy: "• Скачайте и наслаждайтесь вашим дублированным видео!",
    close: "Закрыть",
    processAnotherVideo: "Обработать другое видео"
  },

  // Processing steps
  processingSteps: {
    uploading: "Загрузка видео...",
    extracting: "Извлечение аудио...",
    transcribing: "Транскрибирование речи...",
    translating: "Перевод контента...",
    synthesizing: "Синтез нового голоса...",
    rendering: "Рендеринг финального видео...",
    complete: "Обработка завершена!"
  },

  // Common
  common: {
    minutes: "минут",
    seconds: "секунд",
    loading: "Загрузка...",
    error: "Ошибка",
    success: "Успех"
  },

  // Social media
  socialMedia: {
    title: "Оставайтесь на связи",
    description: "Получайте последние обновления о технологии голоса с ИИ"
  },

  // Services (for Footer)
  services: {
    dubbing: "Дубляж",
    voiceClone: "Дубляж с клонированием голоса",
    newVoice: "Дубляж с новым голосом",
    multilingual: "Многоязычный дубляж",
    multiSpeaker: "Многоголосый дубляж",
    subtitles: "Субтитры",
    subtitlesOnly: "Только субтитры",
    multilingualSubtitles: "Многоязычные субтитры",
    subtitlesDescription: "Автоматически генерируйте точные субтитры для любой платформы.",
    subtitlesPrice: "Стоимость обработки: $0.01/sec",
    addSubtitles: "Добавить субтитры",
    needsTranslation: "Нужен перевод?",
    translationLanguage: "Язык перевода"
  },

  // Footer
  footer: {
    legal: "Правовая информация",
    privacyPolicy: "Политика конфиденциальности",
    termsOfUse: "Условия использования"
  },

  // Navigation
  nav: {
    blog: "Блог"
  },

  // Blog
  blog: {
    title: "Блог VEVI Monster",
    subtitle: "История и мифология вселенной VEVI",
    readMore: "Читать далее",
    backToBlog: "Вернуться к блогу",
    articleNotFound: "Статья не найдена",
    characteristics: "Характеристики",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi — существо, рождённое из плазменных вихрей Zera-13b. Он не из плоти и не из металла — его тело состоит из вибрирующих частиц, удерживаемых электромагнитным полем.",
        metadata: {
          "Галактика": "MoM-z14",
          "Возраст": "13,4 млрд лет",
          "Тип": "Скальная планета с плотной атмосферой из метана и неона",
          "Звезда": "Красный протозвезда Zera-13",
          "Орбита": "Вторая планета системы",
        },
        content: [
          "🌑 Описание",
          "Zera-13b — это древний и почти забытый мир, родившийся в эпоху, когда Вселенная только училась светиться.",
          "Её небо переливается тускло-зелёным пламенем, а плотная атмосфера дрожит от неоновых бурь. Поверхность — чёрно-серый ландшафт, покрытый стекловидными кратерами, где метановые ветра оставляют огненные следы в воздухе.",
          "Под поверхностью скрыты пещеры из замёрзшего газа, в которых, по легендам, зародились первые формы энергии, способные к мысли.",
          "👾 Vevi (Vevi Monster)",
          "Vevi — существо, рождённое из плазменных вихрей Zera-13b.",
          "Он не из плоти и не из металла — его тело состоит из вибрирующих частиц, удерживаемых электромагнитным полем.",
          "Его глаза сияют отражённым светом звезды Zera-13, а голос звучит как шёпот неонового ветра.",
          "Vevi покинул свой мир, когда протозвезда начала угасать. Он отправился сквозь межгалактические пустоты, ведомый инстинктом поиска новой энергии.",
          "Теперь он странствует по мирам, неся с собой частицу первозданного света Zera-13b.",
          "Свечение ему досталось от планеты",
          "У него нет ног — так как на планете огромная гравитация и он просто левитирует",
          "Он разговаривает (а точнее издает звуки) похожие на акустические волны дельфинов, китов, касаток.",
          "Его язык называется UFOnic",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub — существо из ранней Вселенной, родившееся в Sub Zone, редком регионе космоса с высокой плотностью материи.",
        metadata: {
          "Название объекта": "Sub Zone (SUB-Z)",
          "Тип объекта": "Протокластер / область формирования галактик",
          "Эпоха": "~200–300 млн лет после Большого взрыва",
          "Красное смещение": "z ≈ 14–15",
          "Прямое восхождение (RA)": "02h 17m 43s",
          "Склонение (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Данные Baddy Sub",
          "Длинное тонкое продолговатое тело с двумя нижними конечностями внизу и тремя глазами на вытянутых формах вверху",
          "У него нет рта.",
          "Также есть две верхние тонкие конечности, что можно интерпретировать как руки.",
          "На конечностях по 2 пальца.",
          "Все тело напоминает ветку дерева",
          "Кожа имеет гладкую матовую структуру",
          "Окрас зеленовато коричневый (пигментация)",
          "Может менять окрас от обстановки как хамелеон.",
          "Описание планеты где родился Baddy Sub:",
          "Sub Zone — редкий участок ранней Вселенной с высокой плотностью материи, где начинали формироваться первые галактические структуры. Наблюдения указывают на интенсивные взаимодействия первичного газа, излучения и гравитационных волн. В регионе зафиксированы нестабильные сигнальные паттерны и аномальная резонансная активность, нехарактерная для типичных протогалактических областей.",
          "Научная значимость:",
          "Sub Zone считается ключевым объектом для изучения ранних этапов сборки галактик, распространения сигналов в молодой Вселенной и перехода от хаотичных радиационных полей к структурированным космическим системам.",
          "Статус:",
          "Классифицирован как неразрешённая область формирования. Требуются дальнейшие исследования.",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "Часто задаваемые вопросы",
    subtitle: "Все, что вам нужно знать о VEVI",
    questions: [
      {
        question: "Вы работаете только с голосом?",
        answer: "Да — мы заменяем ваш голос так, чтобы он звучал на другом языке, сохраняя естественность и аутентичность."
      },
      {
        question: "Я плачу до или после?",
        answer: "После. Сначала вы слышите результат, потом платите."
      },
      {
        question: "Возврат средств?",
        answer: "Не требуется — вы платите только когда довольны результатом."
      },
      {
        question: "Видео длиннее 5 минут?",
        answer: "Без проблем. Спросите нашего ИИ-ассистента в онлайн-чате для получения инструкций."
      },
      {
        question: "Могу ли я выбрать другой голос?",
        answer: "Нет — мы только клонируем ваш собственный голос."
      },
      {
        question: "Минимальный платеж?",
        answer: "От $0.50."
      },
      {
        question: "Как я получу свое видео?",
        answer: "Мгновенная загрузка в браузере + копия на ваш email после оплаты."
      },
      {
        question: "Скидки для больших заказов?",
        answer: "Да — свяжитесь с нашим ИИ-ассистентом в онлайн-чате."
      },
      {
        question: "Не нашли ответ?",
        answer: "Спросите нашего ИИ-ассистента в онлайн-чате — мы здесь, чтобы помочь."
      },
      {
        question: "Неподдерживаемый формат?",
        answer: "Используйте конвертер или получите быструю помощь от нашего ИИ-ассистента в онлайн-чате."
      },
      {
        question: "В моем видео есть специфические термины, которые должны быть произнесены правильно. Могу ли я это контролировать?",
        answer: "Да — просто напишите нашему ИИ-ассистенту в онлайн-чате, и мы отправим вам инструкции о том, как отметить или сохранить определенные термины (например, оставить их на английском)."
      },
      {
        question: "Я не получил письмо. Что делать?",
        answer: "Время обработки может варьироваться из-за загруженности очереди. Не волнуйтесь — ваш файл в безопасности. Вы получите уведомление или прямую ссылку для скачивания, как только он будет готов."
      }
    ]
  },

  // Pages
  pages: {
    privacy: {
      title: "Политика конфиденциальности VEVI MONSTER",
      lastUpdated: "Последнее обновление: 12 декабря 2025",
      interpretationAndDefinitions: "1. Толкование и определения",
      interpretation: "Толкование",
      interpretationDesc: "Слова с заглавными начальными буквами имеют значения, определенные ниже. Эти определения применяются независимо от того, появляются ли они в единственном или множественном числе.",
      definitions: "Определения",
      definitionsDesc: "Для целей настоящей Политики конфиденциальности:",
      definitionsItems: [
        { term: "Аккаунт", definition: "означает уникальную учетную запись, созданную для Вас для доступа к Нашему Сервису или частям Нашего Сервиса." },
        { term: "Аффилированное лицо", definition: "означает лицо, которое контролирует, контролируется или находится под общим контролем со стороной, где \"контроль\" означает владение 50% или более акций или прав голоса." },
        { term: "Компания", definition: "относится к General Secret OÜ, частной компании с ограниченной ответственностью, зарегистрированной в Эстонии (регистрационный код 17112803), с главным офисом по адресу Vesivärava tn 50-201, Kesklinna linnaosa, Tallinn, Harju maakond, 10152, Эстония." },
        { term: "Файлы cookie", definition: "небольшие файлы, размещенные на Вашем устройстве, которые хранят информацию о Вашей активности просмотра." },
        { term: "Страна", definition: "относится к Эстонии." },
        { term: "Устройство", definition: "означает любое устройство, которое может получить доступ к Сервису, такое как компьютер, смартфон или планшет." },
        { term: "Персональные данные", definition: "означает любую информацию, относящуюся к идентифицированному или идентифицируемому физическому лицу." },
        { term: "Сервис", definition: "относится к веб-сайту, управляемому Компанией: vevi.monster." },
        { term: "Поставщик услуг", definition: "означает любое физическое или юридическое лицо, которое обрабатывает данные от имени Компании." },
        { term: "Данные об использовании", definition: "относится к данным, собранным автоматически при использовании Сервиса." },
        { term: "Веб-сайт", definition: "относится к vevi.monster." },
        { term: "Вы", definition: "означает физическое или юридическое лицо, получающее доступ к Сервису или использующее его." },
      ],
      scope: "2. Область применения настоящей Политики конфиденциальности",
      scopeDesc: "Настоящая Политика конфиденциальности применяется исключительно к Вашему использованию vevi.monster. Она не применяется к сторонним веб-сайтам или сервисам, которые могут быть связаны с Нашего Веб-сайта. Мы не контролируем и не несем ответственности за практики конфиденциальности третьих сторон. Мы рекомендуем Вам ознакомиться с политиками конфиденциальности любых внешних веб-сайтов, которые Вы посещаете.",
      dataController: "3. Контроллер данных",
      dataControllerDesc: "Для целей Общего регламента по защите данных (GDPR) Контроллером данных является:",
      companyName: "General Secret OÜ",
      companyAddress: "Vesivärava tn 50-201, Kesklinna linnaosa, Tallinn, Harju maakond, 10152, Эстония",
      dataControllerEmail: "Email: site@vevi.monster",
      collectingAndUsing: "4. Сбор и использование Ваших Персональных данных",
      typesOfDataCollected: "4.1 Типы собираемых данных",
      personalData: "Персональные данные",
      personalDataDesc: "При использовании Нашего Сервиса Мы можем попросить Вас предоставить определенную личную информацию, включая:",
      personalDataItems: ["Адрес электронной почты"],
      usageData: "Данные об использовании",
      usageDataDesc: "Данные об использовании собираются автоматически и могут включать такую информацию, как:",
      usageDataItems: [
        "IP-адрес",
        "Тип и версия браузера",
        "Информация об устройстве",
        "Посещенные страницы и время, проведенное на страницах",
        "Дата и время посещений",
        "Приблизительное местоположение (на уровне города)",
      ],
      purposesAndLegalBasis: "5. Цели и правовые основания для обработки",
      purposesAndLegalBasisDesc: "Мы обрабатываем Персональные данные для следующих целей:",
      purposesAndLegalBasisItems: [
        "Для предоставления и поддержания Сервиса",
        "Для управления учетными записями пользователей",
        "Для выполнения и управления контрактами",
        "Для связи с Вами по поводу сообщений, связанных с сервисом",
        "Для отправки информационных бюллетеней или маркетинговых сообщений (где предоставлено согласие)",
        "Для управления запросами и запросами пользователей",
        "Для анализа использования и улучшения Сервиса",
        "Для соблюдения правовых обязательств",
      ],
      purposesAndLegalBasisLegalBases: "Правовые основания для обработки могут включать согласие, договорную необходимость, правовые обязательства и законные интересы в соответствии с GDPR.",
      thirdPartyServices: "6. Сторонние сервисы",
      analytics: "6.1 Аналитика",
      googleAnalytics: "Google Analytics 4 (Google Ireland Limited)",
      googleAnalyticsDesc: "Используется для анализа трафика и поведения пользователей.",
      googleAnalyticsData: "Обрабатываемые Персональные данные: информация о браузере, город, информация об устройстве, приблизительное местоположение, статистика сессий",
      googleAnalyticsPlace: "Место обработки: Ирландия",
      googleAnalyticsOptOut: "Пользователи могут отказаться через механизмы отказа Google.",
      advertising: "6.2 Реклама",
      googleAdManager: "Google Ad Manager (Google Ireland Limited)",
      googleAdManagerDesc: "Используется для отображения рекламного контента.",
      googleAdManagerData: "Обрабатываемые Персональные данные: Файлы cookie, Трекеры, Данные об использовании",
      googleAdManagerPlace: "Место обработки: Ирландия",
      googleAdManagerSettings: "Пользователи могут управлять настройками рекламы через Настройки рекламы Google.",
      payments: "6.3 Платежи",
      paymentsDesc: "Сервисы обработки платежей позволяют Нам безопасно обрабатывать платежи. Мы не храним полные данные платежной карты.",
      stripe: "Stripe",
      stripeDesc: "Поставщик услуг обработки платежей.",
      stripeData: "Обрабатываемые Персональные данные: различные типы данных, определенные политикой конфиденциальности Stripe",
      stripePlace: "Место обработки: Соединенные Штаты и другие юрисдикции",
      revolut: "Revolut Payments",
      revolutDesc: "Платежные услуги, предоставляемые компаниями Revolut в пределах Европейского Союза.",
      revolutData: "Обрабатываемые Персональные данные: платежные и идентификационные данные, необходимые для обработки транзакций",
      revolutPlace: "Место обработки: Европейский Союз",
      cookiesAndTracking: "7. Файлы cookie и технологии отслеживания",
      cookiesAndTrackingDesc: "Мы используем Файлы cookie и аналогичные технологии отслеживания для мониторинга активности и улучшения Сервиса. Файлы cookie: небольшие файлы данных, хранящиеся в Вашем браузере. Трекеры: файлы cookie, веб-маяки, скрипты и аналогичные технологии. Вы можете контролировать Файлы cookie через настройки Вашего браузера.",
      sharingOfData: "8. Обмен Вашими Персональными данными",
      sharingOfDataDesc1: "Мы не продаем Ваши Персональные данные.",
      sharingOfDataDesc2: "Мы можем делиться Вашими данными:",
      sharingOfDataItems: [
        "С Поставщиками услуг, действующими от Нашего имени",
        "Для соблюдения правовых обязательств",
        "В связи с передачей бизнеса (например, слияние или поглощение)",
        "В анонимизированной, агрегированной форме для аналитики или бизнес-инсайтов",
      ],
      sharingOfDataDesc3: "Все третьи стороны обязаны обрабатывать Персональные данные безопасно и в соответствии с применимыми законами.",
      dataRetention: "9. Хранение данных",
      dataRetentionDesc: "Мы храним Персональные данные только в течение времени, необходимого для выполнения целей, изложенных в настоящей Политике конфиденциальности, включая соблюдение правовых, бухгалтерских или отчетных требований. Данные об использовании обычно хранятся в течение более короткого периода, если это не требуется для целей безопасности или правовых целей.",
      internationalTransfers: "10. Международные передачи данных",
      internationalTransfersDesc: "Ваши Персональные данные могут обрабатываться за пределами Вашей страны проживания. Мы обеспечиваем наличие соответствующих гарантий для защиты Ваших данных в соответствии с требованиями GDPR. Используя Сервис, Вы соглашаетесь на такие передачи.",
      yourRightsGDPR: "11. Ваши права в соответствии с GDPR",
      yourRightsGDPRDesc: "Вы имеете право:",
      yourRightsGDPRItems: [
        "Получить доступ к Вашим Персональным данным",
        "Исправить неточные данные",
        "Запросить удаление Ваших данных",
        "Ограничить или возразить против обработки",
        "На переносимость данных",
        "Отозвать согласие в любое время",
      ],
      yourRightsGDPRContact: "Для осуществления Ваших прав, пожалуйста, свяжитесь с Нами по адресу site@vevi.monster.",
      deletionOfData: "12. Удаление Персональных данных",
      deletionOfDataDesc: "Вы можете запросить удаление Ваших Персональных данных в любое время. Некоторые данные могут быть сохранены, если это требуется по закону или для законных деловых целей.",
      disclosureOfData: "13. Раскрытие Персональных данных",
      disclosureOfDataDesc: "Мы можем раскрывать Персональные данные:",
      disclosureOfDataItems: [
        "Для соблюдения правовых обязательств",
        "Для защиты прав или собственности Компании",
        "Для предотвращения или расследования правонарушений",
        "Для защиты безопасности Пользователей или общественности",
      ],
      securityOfData: "14. Безопасность Ваших Персональных данных",
      securityOfDataDesc: "Мы применяем соответствующие технические и организационные меры для защиты Персональных данных. Однако ни один метод передачи через Интернет не является полностью безопасным.",
      childrenPrivacy: "15. Конфиденциальность детей",
      childrenPrivacyDesc: "Наш Сервис не предназначен для детей в возрасте до 13 лет. Мы не собираем намеренно Персональные данные от детей. Если Вы считаете, что ребенок предоставил Нам Персональные данные, пожалуйста, свяжитесь с Нами.",
      linksToOtherWebsites: "16. Ссылки на другие веб-сайты",
      linksToOtherWebsitesDesc: "Наш Сервис может содержать ссылки на сторонние веб-сайты. Мы не несем ответственности за их содержание или практики конфиденциальности.",
      changesToPolicy: "17. Изменения в настоящей Политике конфиденциальности",
      changesToPolicyDesc: "Мы можем время от времени обновлять настоящую Политику конфиденциальности. Изменения будут опубликованы на этой странице с обновленной датой пересмотра.",
      contactUs: "18. Свяжитесь с нами",
      contactUsDesc: "Если у Вас есть вопросы о настоящей Политике конфиденциальности или Наших практиках обработки данных, пожалуйста, свяжитесь с Нами:",
      contactEmail: "Email: site@vevi.monster",
      contactCompany: "Компания: General Secret OÜ",
      contactAddress: "Адрес: Vesivärava tn 50-201, Kesklinna linnaosa, Tallinn, Harju maakond, 10152, Эстония",
    },
    terms: {
      title: "Условия использования VEVI MONSTER",
      lastUpdated: "Последнее обновление: 12 декабря 2025",
      definitions: "1. Определения",
      definitionsItems: [
        { term: "Аккаунт", definition: "Уникальная учетная запись, созданная для Вас для доступа к Сервису." },
        { term: "Контент", definition: "Любой текст, изображения, аудио, видео или другие материалы, загруженные, отправленные или иным образом предоставленные через Сервис." },
        { term: "Результаты", definition: "Результаты услуг, выполненных по соглашениям с Нами, включая финальное аудио, видео или другие творческие результаты." },
        { term: "Пользователь", definition: "Физическое или юридическое лицо, получающее доступ к Сервису или использующее его." },
        { term: "Вы", definition: "Пользователь." },
        { term: "Поставщик услуг", definition: "Сторонние компании или физические лица, помогающие Нам в предоставлении Сервиса." },
      ],
      useOfService: "2. Использование Сервиса",
      useOfService21: "2.1. Вы соглашаетесь использовать Сервис только в законных целях.",
      useOfService22: "2.2. Вы не должны загружать, публиковать или передавать любой контент, который является незаконным, вредным, оскорбительным или нарушает права третьих лиц.",
      useOfService23: "2.3. Сервис может включать ссылки на сторонние веб-сайты. Мы не несем ответственности за содержание или практики этих третьих сторон.",
      accountRegistration: "3. Регистрация аккаунта",
      accountRegistration31: "3.1. Вам может потребоваться создать Аккаунт для доступа к определенным функциям Сервиса.",
      accountRegistration32: "3.2. Вы несете ответственность за сохранение конфиденциальности учетных данных Вашего Аккаунта и за все действия под Вашим Аккаунтом.",
      accountRegistration33: "3.3. Вы должны немедленно уведомить Нас о любом несанкционированном использовании Вашего Аккаунта.",
      paymentAndSubscriptions: "4. Платежи и подписки",
      paymentAndSubscriptions41: "4.1. Некоторые услуги могут требовать оплаты. Все сборы указываются в момент покупки.",
      paymentAndSubscriptions42: "4.2. Платежи обрабатываются безопасно через сторонних поставщиков (например, Stripe, Revolut).",
      paymentAndSubscriptions43: "4.3. Вы соглашаетесь предоставлять точную платежную информацию и оплачивать все понесенные расходы.",
      paymentAndSubscriptions44: "4.4. Возвраты средств, если таковые имеются, регулируются политиками конкретного Сервиса, предоставленными в момент покупки.",
      intellectualPropertyRights: "5. Права интеллектуальной собственности",
      intellectualPropertyRights51: "5.1. Все Результаты, созданные Компанией для Вас, становятся Вашей исключительной собственностью после принятия и оплаты.",
      intellectualPropertyRights52: "5.2. В максимальной степени, разрешенной применимым законодательством, Компания настоящим передает и уступает Вам все экономические авторские права на Результаты по всему миру на срок действия защиты авторских прав, охватывая все известные области использования, включая, но не ограничиваясь:",
      intellectualPropertyRights52Items: [
        "Воспроизведение, распространение и демонстрация;",
        "Публичное распространение через Интернет, социальные сети, потоковые платформы или платформы VOD;",
        "Создание производных произведений;",
        "Коммерческое использование, ссуда или аренда.",
      ],
      intellectualPropertyRights53: "5.3. В максимальной степени, разрешенной законом, Компания не будет осуществлять моральные права, которые могли бы помешать Вашему использованию Результатов.",
      intellectualPropertyRights54: "5.4. Если Результаты не подлежат защите авторских прав (например, созданные ИИ), Вы получаете неограниченное, бессрочное, всемирное, безотзывное право использовать, изменять и эксплуатировать их любым способом без дальнейших претензий.",
      userContent: "6. Контент пользователя",
      userContent61: "6.1. Вы сохраняете право собственности на любой контент, который Вы загружаете в Сервис, но предоставляете Нам неисключительную, всемирную, безвозмездную лицензию на использование, воспроизведение, изменение и отображение его в целях предоставления Сервиса.",
      userContent62: "6.2. Вы заявляете и гарантируете, что у Вас есть все необходимые права для загрузки контента и что он не нарушает права третьих лиц.",
      privacy: "7. Конфиденциальность",
      privacyDesc: "Ваше использование Сервиса также регулируется Нашей Политикой конфиденциальности, которая описывает, как Мы собираем и обрабатываем Персональные данные.",
      termination: "8. Прекращение",
      termination81: "8.1. Мы можем приостановить или прекратить Ваш Аккаунт, если Вы нарушите эти Условия.",
      termination82: "8.2. Вы можете прекратить Ваш Аккаунт в любое время, связавшись с Нами.",
      limitationOfLiability: "9. Ограничение ответственности",
      limitationOfLiability91: "9.1. Сервис предоставляется \"как есть\" и \"как доступно\".",
      limitationOfLiability92: "9.2. В максимальной степени, разрешенной законом, Компания не несет ответственности за любой косвенный, случайный или последующий ущерб, возникающий в результате использования Сервиса.",
      indemnification: "10. Возмещение ущерба",
      indemnificationDesc: "Вы соглашаетесь возместить, защитить и оградить Компанию, ее аффилированные лица и Поставщиков услуг от любых претензий, ущерба, обязательств или расходов, возникающих в результате Вашего использования Сервиса или нарушения этих Условий.",
      governingLaw: "11. Применимое право",
      governingLawDesc: "Эти Условия регулируются законами Эстонии, без учета принципов коллизионного права.",
      changesToTerms: "12. Изменения в Условиях",
      changesToTermsDesc: "Мы можем время от времени обновлять эти Условия. Изменения будут опубликованы на этой странице с обновленной датой пересмотра.",
      contactInformation: "13. Контактная информация",
      contactInformationDesc: "",
      companyName: "Компания: General Secret OÜ",
      companyAddress: "Адрес: Vesivärava tn 50-201, Kesklinna linnaosa, Tallinn, Harju maakond, 10152, Эстония",
      contactEmail: "Email: site@vevi.monster",
    },
  },
};
